<template>
  <div>

    <div v-html="$t('users.importExcel')"></div>

    <div class="form-group mt-4">

      <div>
        <label class="font-weight-bold">1. {{ $t('reports.btns.download_title') }}</label>
      </div>

      <b-button @click="exportEmptyFile">
        <span>
          <i class='fa fa-spinner fa-spin' v-if="loadingExport" style="margin-right: 10px"></i>
          <i v-else class="fa fa-download" style="margin-right: 10px"></i>
          {{ $t('reports.btns.downloadModel') }}
        </span>
      </b-button>

    </div>
    <div class="form-group mt-4">
      <div>
        <span class="d-inline-block font-weight-bold">2. {{ $t('reports.btns.completeModel') }}</span>
        <span class="font-weight-light" style="font-size: 14px">{{ $t('reports.btns.completeModelNote') }}</span>
      </div>
    </div>

    <div class="form-group mt-4">

      <label class="font-weight-bold">3. {{ $t('reports.btns.importModel') }}</label>

      <b-form-file
          :browse-text="$t('reports.btns.selection')" :placeholder="noFile" v-model="file" id="file-small"
          class="mb-3 ">
      </b-form-file>

      <b-button :disabled="!file" @click="importFile">
        <i class='fa fa-spinner fa-spin' v-if="loadingImport" style="margin-right: 10px"></i>
        <i v-else class="fa fa-upload" style="margin-right: 10px"></i>
        <span>{{ $t('users.importFile') }}</span>
      </b-button>

    </div>

    <div v-if="error" class="alert alert-danger mt-4 mb-3" role="alert">

      <strong>{{ $t('users.fail') }}</strong>
      <br>
      {{ errorMessage }}
      <br>
      {{ errorValue }}

    </div>

    <div v-if="sentWithError" class="alert alert-warning mt-4" role="alert">

      <strong>{{ $t('users.errorMessages.warning') }}</strong>
      <br>
      <div>
        <span>{{ $t('users.errorMessages.import_has_error') }}</span>
      </div>

    </div>
    <div v-if="sent" class="alert alert-success mt-4" role="alert">

      <strong>{{ $t('users.success') }}</strong>
      <br>
      <div>
        <span> {{ $t('users.sendingConfirmation1') }}</span>
        <br>
        <span v-if="smsSent > 0" class="d-inline-block">{{ $tc('users.sendingConfirmationSMS', smsSent, {countSMS: smsSent}) }}</span>
        <span v-if="emailSent > 0"class="d-inline-block">{{ $tc('users.sendingConfirmationEmail', emailSent, {countEmail: emailSent}) }}</span>
      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import Utils from "@/services/utils.js";
import API from '@/services/API.js';
import moment from "moment";

export default {
  name: 'excelManagement',
  props: {
    licencesIds: {
      type: Array
    }
  },
  data() {
    return {
      file: null,
      loadingExport: false,
      loadingImport: false,
      error: false,
      errorMessage: '',
      errorValue: '',
      sent: false,
      sentWithError: false,
      noFile: Utils.t('users.noFile')
    }
  },
  mounted() {
    this.sent = false
    this.sentWithError = false
  },
  methods: {

    reload() {
      this.$emit('reload')
    },
    exportEmptyFile() {
      var outputFormat = 'xls'
      this.loadingExport = true
      // TODO : send selected ids
      axios.post(API.endpoints.licences.export + '?perpage=99999&page=1', {list_licence: this.licencesIds},
          {
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.ms-excel',
            }
          })
          .then(response => {
            const date = moment().format("YYYYMMDD")

            var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput(outputFormat)})

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, this.constructReportFileName + "." + outputFormat);
              return;
            }
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = `${Utils.getApplicationNameNormalized().toLowerCase()}-template_` + date + "." + outputFormat;
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
            this.lockDLBtn = false;
            this.$emit('can-continue', {value: true})
            this.loadingExport = false
          })
    },
    importFile() {
      this.loadingImport = true
      this.error = false
      this.sent = false
      this.smsSent = Number
      this.emailSent = Number

      let objectToSend = new FormData();
      objectToSend.append('file', this.file);

      axios.post(API.endpoints.licences.import + '?perpage=99999&page=1&devices=0',
          objectToSend,
          {
            headers: {
              'Accept': 'application/vnd.ms-excel',
              'Content-type': 'application/json',
            }
          })
          .then(response => {
            if (typeof response.data.uniq_key !== 'undefined') {
              this.downloadErrorFile(response)
              this.sentWithError = true
            } else {
              this.sent = true
              this.smsSent = response.data.message.nb_sms_envoyes
              this.emailSent = response.data.message.nb_emails_envoyes
            }

            this.loadingImport = false
            this.$emit('reload')
            setTimeout(this.removeMessage, 6000);
          }).catch(error => {
            this.loadingImport = false
            this.error = true
            const errMsg = error?.response?.data?.message?.message
            this.errorMessage = window.V.$i18n.te('users.errorMessages.' + errMsg) ? window.V.$i18n.t('users.errorMessages.' + errMsg) : window.V.$i18n.t('users.errorMessages.default')
            this.errorValue = error?.response?.data?.message?.value
          })
      this.file = null
    },
    downloadErrorFile(response) {
      axios.get(API.endpoints.licences.errorLogImport + "?id=" + response.data.uniq_key, {},
          {
            responseType: 'blob',
            headers: {
              'Accept': 'plain/text',
            }
          })
          .then(response => {
            const date = moment().format("YYYYMMDD")

            var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput("txt")})

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, this.constructReportFileName + ".txt");
              return;
            }
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = "beepiz-error-import" + date + ".txt";
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
            this.lockDLBtn = false;
            this.$emit('can-continue', {value: true})
            this.loadingExport = false
          })
    },
    removeMessage() {
      this.sent = false
    },
    canContinue() {
      this.$emit('can-continue', {value: true})
    }
  }
}
</script>

<style>
</style>
